import React, { useContext } from "react";
import { CombinedContext } from "../../../context/combinedContext";
import translations from "../../../translations/translations";
import LegalDoc from "../legalDoc/legalDoc";

const COMPANY_NAME = "Sin Fila";
const CONTACT_EMAIL = "hola@reservasinfila.com";
const LAST_UPDATED = "October 14, 2025";

const fill = (text = "") =>
	typeof text === "string"
		? text.replace("{{COMPANY_NAME}}", COMPANY_NAME).replace("{{CONTACT_EMAIL}}", CONTACT_EMAIL)
		: "";

const paragraphs = (section) =>
	Object.keys(section || {})
		.filter((key) => /^p\d+$/.test(key))
		.sort((a, b) => Number(a.slice(1)) - Number(b.slice(1)))
		.map((key) => fill(section[key]))
		.filter(Boolean);

const Terms = () => {
	const { language } = useContext(CombinedContext);
	const t = translations[language].terms;

	const sections = [
		{ id: "introduction", heading: t.intro.heading, paragraphs: paragraphs(t.intro) },
		{ id: "eligibility", heading: t.eligibility.heading, list: t.eligibility.list },
		{ id: "accounts", heading: t.accounts.heading, list: t.accounts.list },
		{ id: "bookings", heading: t.bookings.heading, paragraphs: paragraphs(t.bookings) },
		{ id: "professional-responsibilities", heading: t.proResponsibilities.heading, list: t.proResponsibilities.list },
		{ id: "acceptable-use", heading: t.acceptableUse.heading, list: t.acceptableUse.list },
		{ id: "user-content", heading: t.userContent.heading, paragraphs: paragraphs(t.userContent) },
		{ id: "intellectual-property", heading: t.ip.heading, paragraphs: paragraphs(t.ip) },
		{ id: "disclaimer", heading: t.disclaimer.heading, paragraphs: paragraphs(t.disclaimer) },
		{ id: "liability", heading: t.liability.heading, paragraphs: paragraphs(t.liability) },
		{ id: "indemnity", heading: t.indemnity.heading, paragraphs: [t.indemnity.text] },
		{ id: "termination", heading: t.termination.heading, paragraphs: [t.termination.text] },
		{ id: "privacy", heading: t.privacy.heading, paragraphs: [t.privacy.text] },
		{ id: "governing-law", heading: t.law.heading, paragraphs: [t.law.text] },
		{ id: "changes", heading: t.changes.heading, paragraphs: [t.changes.text] },
		{ id: "miscellaneous", heading: t.misc.heading, list: t.misc.list },
	];

	return (
		<LegalDoc
			title={t.title}
			lastUpdatedLabel={t.lastUpdated}
			lastUpdatedValue={LAST_UPDATED}
			sections={sections}
		/>
	);
};

export default Terms;
